export * from "./rbac";
export * from "./money";
export * from "./schemas";
export * from "./dto";

/** Document-number formatting shared by the API and any preview UI. */
export function formatDocNumber(n: number, prefix = "", pad = 6): string {
  return `${prefix}${String(n).padStart(pad, "0")}`;
}

/**
 * Contact snapshots are stored as multi-line blobs ("Name\nAddress: …").
 * Lists show only the name line; returns null when there is nothing to show.
 */
export function contactSnapshotName(s: string | null | undefined): string | null {
  const first = (s ?? "").split("\n")[0]?.trim();
  return first ? first : null;
}
export * from "./csv";
export * from "./label";
export * from "./piProgress";
export * from "./productProfit";
export * from "./piStatus";
export * from "./documentMail";
export * from "./productFiles";
export * from "./productStock";
export * from "./productMaterial";
export * from "./optionLabels";

export { pickEffective, resolveSellingPrice, type PriceRow, type PriceTier, type SellingPriceResult, type SellingPriceSource } from "./priceResolution";

export * from "./sampleOrders";
export * from './warehouseReceipts';
export * from './iqc';
export * from './lotTransfers';
export * from './boms';
export * from './routings';
export * from './requisitions';
export * from './salesOrders';
export * from './unitPricing';
export * from './mrp';
export * from './sourcing';

export * from "./production";

export * from "./productionMaterials";

export * from "./qualitySpecs";

export * from "./productionExecution";
export * from "./lotReservations";
export * from "./stockCounts";
export * from "./subcontract";
export * from "./ncr";
export * from "./salesIssues";
export * from "./documentPricing";
export * from "./gl";
export * from "./kpis";
export * from "./devices";
export * from "./costing";
export * from "./opportunities";
export * from "./claims";
export * from "./serviceTickets";
export * from "./supplierClaims";
export * from "./access";
export * from "./accessTemplates";
export * from "./pProcess";
export * from "./orderProcess";
export * from "./description";
export * from "./portalLogin";
export * from "./vnTime";
export * from "./salesReference";
export * from "./privateSupplier";
export * from "./fx";
export * from "./featurePreview";
export * from "./warehouseBins";
